import { render, staticRenderFns } from "./WorkflowPrepIndex.vue?vue&type=template&id=37e87317"
import script from "./WorkflowPrepIndex.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports